import React, { useContext } from 'react';
import { Route, Routes } from 'react-router-dom';
import { AuthContext, useAuth } from './auth/AutoContextProvider';
import Auth from './auth/components/Auth';
import Login from './auth/components/Login';
import BuildMii from './build-mii/components/buildMii';
import BuildMiiTestPage from './build-mii-test/components/buildMiiTestPage';
import BuildMiiTypeForm from './build-mii-typeform/components/buildMiiTypeForm';
import BuildMiiJd from './build-mii/components/buildMiiJd';
import Protected from './common/components/Protected';
import DiscoveryMii from './discovery-notepad/components/discoveryMii';
import DiscoveryMiiForm from './discovery-notepad/components/discoveryMiiForm';
import Home from './home/components/Home';
import TypeFormNavigator from './common/components/TypeFormNavigator';
import NotFound from './common/components/Errors/NotFound';
import NotAuthorized from './common/components/Errors/NotAuthorized';

const RouterComponent  = () => {
  const {state} = useContext(AuthContext)
  const [_,{getCookie}] = useAuth();
  const token = getCookie('tkn-ath');
  const refreshToken = getCookie('tkn-ath-rfrsh');
  const isAuthenticated = refreshToken != "undefined" ? true : false;

   return (    
        <Routes>
          <Route path="/" element={<Auth/>}/>
          <Route path="/Auth" element={<Auth/>}/>
          <Route path="/Login" element={<Login/>}/>
          <Route path="/Home" element={<Protected isAuthenticated={isAuthenticated}><Home/></Protected>}/>
          <Route path="/BuildMii" element={<Protected isAuthenticated={isAuthenticated}><BuildMii/></Protected>}/>
          <Route path="/BuildMii/Test" element={<Protected isAuthenticated={isAuthenticated}><BuildMiiTestPage/></Protected>}/>
          <Route path="/BuildMii/JobDescription" element={<Protected isAuthenticated={isAuthenticated}><BuildMiiJd/></Protected>}/>
          <Route path="/DiscoveryMii" element={<Protected isAuthenticated={isAuthenticated}><DiscoveryMii/></Protected>}/>
          <Route path="/DiscoveryMii/Form" element={<Protected isAuthenticated={isAuthenticated}><DiscoveryMiiForm/></Protected>}/>
          <Route path="/TypeForm/form/:id" element={<Protected isAuthenticated={isAuthenticated}><BuildMiiTypeForm/></Protected>}/>
          <Route path="/TypeForm" element={<TypeFormNavigator/>}/>
          <Route path="/Unauthorized" element={<NotAuthorized/>}/>
          <Route path="*" element={<NotFound/>} />
        </Routes>
    )
  }

  export default RouterComponent 